import React from 'react';
import { useTranslation } from '@lt/localization';
import classnames from 'classnames';
import { TEST_ID_NOT_ENOUGH_REVIEW_TEXT } from './constants';

import styles from './notEnoughtReviews.module.css';

interface Props {
  isEmptyReviews: boolean;
  className?: string;
  isMobile?: boolean;
}

const NotEnoughReviews = ({
  isEmptyReviews,
  className = '',
  isMobile,
}: Props) => {
  const { t } = useTranslation();
  const title = isEmptyReviews
    ? t('hotel.reviews.emptyTitle')
    : t('hotel.reviews.fewTitle');
  return (
    <div
      className={classnames(styles.container, className, {
        [styles.mobileContainer]: isMobile,
      })}
    >
      <div
        className={classnames(styles.title, { [styles.mobileTitle]: isMobile })}
        data-testid={TEST_ID_NOT_ENOUGH_REVIEW_TEXT}
      >
        {title}
      </div>
      <div className={styles.description}>
        {t('hotel.reviews.emptySubtitle')}
      </div>
    </div>
  );
};

export default NotEnoughReviews;
